import React, { useRef, useState } from "react";
import Minus from "../assets/icons/Minus";
import Plus from "../assets/icons/Plus";
import { t } from "i18next";

const Faq = ({ title, faqs, faqimg }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const answerRefs = useRef([]);

  const toggleFaq = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <section className="hr_faq_section">
      <div className="wrapper">
        <h2 className="subtitle_common">
        {t("frequently_asked")} <span className="text-primary">{t("questions")}</span>
        </h2>
        <div className="faq_grid">
          <div className="faq_list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq_item ${activeIndex === index ? "active" : ""}`}
                onClick={() => toggleFaq(index)}
              >
                <div className="faq_question">
                  <h3>{faq.question}</h3>
                  <span className="toggle_icon">
                    {activeIndex === index ? <Minus /> : <Plus />}
                  </span>
                </div>
                <div
                  className="faq_answer"
                  ref={(el) => (answerRefs.current[index] = el)}
                  style={{
                    maxHeight:
                      activeIndex === index
                        ? answerRefs.current[index]?.scrollHeight + "px"
                        : "0px",
                  }}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="faq_img">
            <img src={faqimg} alt="Faq" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
